export type HubSpotWindow = typeof window & {
    hsConversationsSettings?: {
        identificationEmail?: string;
        identificationToken?: string;
    };
    HubSpotConversations?: {
        clear?: (options?: { resetWidget?: boolean }) => void;
        widget?: {
            load?: () => void;
            open?: () => void;
            refresh?: () => void;
            remove?: () => void;
            status?: () => {
                loaded?: boolean;
            };
        };
    };
};

/**
 * Opens the HubSpot support chat, which McpApp loads for Pro accounts only. Returns false when the
 * widget isn't there (not loaded, blocked by the browser or still loading), so the caller can say so.
 */
export function openSupportChat(): boolean {
    const widget = (window as HubSpotWindow).HubSpotConversations?.widget;
    if (!widget?.open || widget.status?.().loaded !== true) {
        return false;
    }
    widget.open();
    return true;
}
